export interface ApiError {
  Error: string;
  TraceId?: string;
  Stack?: string;
  Code?: string;
}

export class ApiErrorWithStack extends Error {
  stack?: string;
  originalError?: Error;
  cause?: Error;
  traceId?: string;
  code?: string;
  requestInfo?: {
    url: string;
    method: string;
    headers?: HeadersInit;
  };

  constructor(
    message: string,
    originalError?: Error,
    requestInfo?: { url: string; method: string; headers?: HeadersInit },
    traceId?: string,
    code?: string
  ) {
    super(message);
    this.name = 'ApiErrorWithStack';
    this.originalError = originalError;
    this.stack = originalError?.stack;
    this.cause = originalError;
    this.requestInfo = requestInfo;
    this.traceId = traceId;
    this.code = code;
  }

  toString(): string {
    let result = `${this.name}: ${this.message}`;

    if (this.traceId) {
      result += ` (TraceId: ${this.traceId})`;
    }

    if (this.requestInfo) {
      result += `\nRequest: ${this.requestInfo.method} ${this.requestInfo.url}`;
    }

    if (this.originalError) {
      result += `\nCaused by: ${this.originalError}`;
    }

    if (this.stack) {
      result += `\nStack trace:\n${this.stack}`;
    }

    return result;
  }
}
